import { UserManager, WebStorageStateStore } from "oidc-client-ts";

// --- CONFIGURACIÓN DEL SERVIDOR DE IDENTIDAD ---
// Los endpoints se auto-descubren desde /.well-known/openid-configuration
const AUTHORITY_URL = "https://devatm.auth.atmexicana.com.mx";
const CLIENT_ID = "DevIAVE_ATM";
const CLIENT_SECRET = "";

const CLIENT_ROOT_URL = "https://deviave.atmexicana.com.mx/";

const oidcConfig = {
  authority: AUTHORITY_URL,
  client_id: CLIENT_ID,
  client_secret: CLIENT_SECRET,

  redirect_uri: `${CLIENT_ROOT_URL}callback`,
  post_logout_redirect_uri: `${CLIENT_ROOT_URL}`,

  response_type: "code",
  scope: "openid",

  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
};

export const userManager = new UserManager(oidcConfig);

// Exportamos configuración para uso manual en AuthContext
export const IDP_CONFIG = {
    token_endpoint: `${AUTHORITY_URL}/oauth2/token`,
    client_id: CLIENT_ID,
    client_secret: CLIENT_SECRET,
    scope: oidcConfig.scope
};
